import {
    faPaperPlane,
    faTrash,
    faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";
import Table from "../../../../Components/Table";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { ListarConfigEnvelopeController } from "../../../../Controllers/Geral/Envelopes/EnvelopesControllers";
import {
    BuscarInformacoesEnvelopeController,
    InserirEnvelopeDocusignController,
    ListarContratosCasoController,
} from "../../../../Controllers/Geral/Email/EmailController";
import useArrayState from "../../../../hooks/useArrayState";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import {
    IDocumentosAdicionais,
    IEnvelopeDocusignConfig,
} from "../../../../Interfaces/Geral/Envelopes/EnvelopesInterface";
import { IListarContratosCaso } from "../../../../Interfaces/Geral/Email/EmailInterface";

// Props Interface
interface IConfigurarEnvelopeEnvioProps {
    idEnvelopeDocusignConfig: number;
    documentosAdicionais: Array<IDocumentosAdicionais>;
}

export default function ConfigurarEnvelopeEnvio(
    props: IConfigurarEnvelopeEnvioProps
) {
    const { ID_CASO } = useAtendimentoPage();

    const { value: informacoesEnvelope, loading: informacoesEnvelopeLoading } =
        useAsyncEffect(async () => {
            if (props.idEnvelopeDocusignConfig) {
                return BuscarInformacoesEnvelopeController(
                    props.idEnvelopeDocusignConfig
                );
            }
        }, [props.idEnvelopeDocusignConfig]);

    console.log(informacoesEnvelope);

    const [lstEnvelopesLst, setLstEnvelopesLst] =
        useArrayState<IEnvelopeDocusignConfig>();
    const [documentoExcluidos, setDocumentosExcluidos] =
        useArrayState<IEnvelopeDocusignConfig>();

    const [fetchedDocumentosAdicionais, setFetchedDocumentosAdicionais] =
        useArrayState<IDocumentosAdicionais>();

    const [lstDocsCaso, setLstDocsCaso] = useArrayState<IListarContratosCaso>();
    const [documentoCasoExcluidos, setDocumentoCasoExcluidos] =
        useArrayState<IListarContratosCaso>();

    const { value: configEnvelopesLst, loading: configEnvelopesLstLoading } =
        useAsyncEffect(() =>
            ListarConfigEnvelopeController(props.idEnvelopeDocusignConfig)
        );

    const { loading: lstContratosCasoLoading } = useAsyncEffect(async () => {
        if (ID_CASO) {
            const res = await ListarContratosCasoController(ID_CASO);
            if (res) {
                res.forEach((doc) => {
                    setLstDocsCaso.add(doc);
                });
            }
            return res;
        }
    }, [ID_CASO]);

    const { execute: executeInserirEnvelope, loading: inserirEnvelopeLoading } =
        useAsyncCallback(InserirEnvelopeDocusignController);

    useEffect(() => {
        if (configEnvelopesLst) {
            //@ts-ignore
            setLstEnvelopesLst.add(configEnvelopesLst);
            //@ts-ignore
            setFetchedDocumentosAdicionais.add(props.documentosAdicionais);
        }
    }, [
        configEnvelopesLst,
        props.documentosAdicionais,
        setLstEnvelopesLst,
        setFetchedDocumentosAdicionais,
    ]);

    // Table Columns
    const tableviewColumns: Array<ColumnDescription<IEnvelopeDocusignConfig>> =
        [
            {
                dataField: "NR_ORDEM",
                text: "Ordem",
                formatter: (_, __, index) => <span>{index + 1}</span>,
            },
            {
                dataField: "DS_TIPO_DOCUMENTO",
                text: "Tipo Documento",
            },
            {
                dataField: "DS_DOCUMENTO",
                text: "Arquivo",
                formatter: (_, row) =>
                    row.DS_DOCUMENTO ? (
                        <span className="text-primary">{row.DS_DOCUMENTO}</span>
                    ) : (
                        <span className="text-secondary">
                            {row.DS_DOCUMENTO_PRODUTO}
                        </span>
                    ),
            },
            {
                dataField: "Ações",
                text: "Ações",
                isDummyField: true,
                formatter: (_, row) =>
                    row.FL_DOCUMENTO_FILHO ? (
                        <div
                            key={row.ID_ENVELOPE_DOCUSIGN_CONFIG_DOCUMENTO}
                            className="d-flex justify-content-center"
                        >
                            <button
                                className="btn btn-outline-danger btn-sm"
                                title="Remover documento"
                                onClick={() => {
                                    setDocumentosExcluidos.add(row);
                                    setLstEnvelopesLst.remove(row);
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} />
                            </button>
                        </div>
                    ) : (
                        <div className="text-muted text-center">
                            <small>Obrigatório</small>
                        </div>
                    ),
            },
        ];

    const tableviewDocumentosCasoColumns: Array<
        ColumnDescription<IListarContratosCaso>
    > = [
        {
            dataField: "DS_NOME_TEMPLATE",
            text: "Documento",
        },
        {
            dataField: "Ações",
            text: "Ações",
            isDummyField: true,
            formatter: (_, row) => (
                <div className="d-flex justify-content-center">
                    <button
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => {
                            setDocumentoCasoExcluidos.add(row);
                            setLstDocsCaso.remove(row);
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} />
                    </button>
                </div>
            ),
        },
    ];

    const tableviewDocumentosAdicionaisColumns: Array<
        ColumnDescription<IDocumentosAdicionais>
    > = [
        {
            dataField: "DS_NOME_ARQUIVO",
            text: "Arquivo",
            formatter: (_, row) =>
                row.DS_NOME_ARQUIVO ? (
                    <span className="text-primary">{row.DS_NOME_ARQUIVO}</span>
                ) : row.DS_DOCUMENTO ? (
                    <span className="text-primary">{row.DS_DOCUMENTO}</span>
                ) : (
                    <span className="text-secondary">
                        {row.DS_DOCUMENTO_PRODUTO}
                    </span>
                ),
        },
        {
            dataField: "Ações",
            text: "Ações",
            isDummyField: true,
            formatter: (_, row) =>
                row.FL_DOCUMENTO_FILHO ? (
                    <div
                        key={row.ID_DOCUMENTO_PRODUTO}
                        className="d-flex justify-content-center"
                    >
                        <button
                            className="btn btn-outline-danger btn-sm"
                            title="Remover documento"
                            onClick={() => {
                                setFetchedDocumentosAdicionais.remove(row);
                            }}
                        >
                            <FontAwesomeIcon icon={faTrash} />
                        </button>
                    </div>
                ) : (
                    <div className="text-muted text-center">
                        <small>Obrigatório</small>
                    </div>
                ),
        },
    ];

    return (
        <>
            <div className="row">
                <div className="col-6">
                    <div className="card shadow-sm mb-4">
                        <div className="card-header bg-white d-flex justify-content-between align-items-center">
                            <h5 className="mb-0">Documentos</h5>
                            {documentoExcluidos?.length > 0 &&
                                documentoExcluidos.some(
                                    (doc) => doc.FL_DOCUMENTO_FILHO
                                ) && (
                                    <button
                                        className="btn btn-outline-primary btn-sm"
                                        onClick={() => {
                                            documentoExcluidos
                                                .filter(
                                                    (doc) =>
                                                        doc.FL_DOCUMENTO_FILHO
                                                )
                                                .forEach((doc) => {
                                                    setLstEnvelopesLst.add(doc);
                                                });
                                            setDocumentosExcluidos.reset();
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faPlus}
                                            className="mr-2"
                                        />
                                        Restaurar documentos removidos
                                    </button>
                                )}
                        </div>
                        <div className="card-body p-0">
                            {lstEnvelopesLst && (
                                <Table
                                    wrapperClasses="mw-100"
                                    columns={tableviewColumns}
                                    data={lstEnvelopesLst}
                                    keyField="ID_ENVELOPE_DOCUSIGN_CONFIG_DOCUMENTO"
                                    noDataIndication={() => (
                                        <div className="text-black-50 text-center p-3">
                                            Nenhum Documento Encontrado
                                        </div>
                                    )}
                                    noHover
                                    noSearch
                                    loading={configEnvelopesLstLoading}
                                    rowStyle={{ height: 50 }}
                                    bordered={false}
                                    defaultStyle={{ align: "center" }}
                                    striped={true}
                                    rowClasses={"rowClasses"}
                                    center={true}
                                    noPagination={true}
                                    sizePerPage={100}
                                />
                            )}
                        </div>
                    </div>
                </div>

                <div className="col-6">
                    <div className="card shadow-sm mb-4">
                        <div className="card-header bg-white d-flex justify-content-between align-items-center">
                            <h5 className="mb-0">Documentos Do Caso</h5>
                            {documentoCasoExcluidos?.length > 0 && (
                                <button
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() => {
                                        documentoCasoExcluidos.forEach(
                                            (doc) => {
                                                setLstDocsCaso.add(doc);
                                            }
                                        );
                                        setDocumentoCasoExcluidos.reset();
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={faPlus}
                                        className="mr-2"
                                    />
                                    Restaurar documentos removidos
                                </button>
                            )}
                        </div>
                        <div className="card-body p-0">
                            <Table
                                wrapperClasses="mw-100"
                                columns={tableviewDocumentosCasoColumns}
                                data={lstDocsCaso ?? []}
                                loading={lstContratosCasoLoading}
                                keyField="ID_CASO_DOCUMENTO_GERADO"
                                noHover
                                noSearch
                                rowStyle={{ height: 50 }}
                                bordered={false}
                                defaultStyle={{ align: "center" }}
                                striped={true}
                                rowClasses={"rowClasses"}
                                center={true}
                                noPagination={true}
                                sizePerPage={100}
                            />
                        </div>
                    </div>
                </div>

                <div className="col-6">
                    <div className="card shadow-sm mb-4">
                        <div className="card-header bg-white">
                            <h5 className="mb-0">Documentos Adicionais</h5>
                        </div>
                        <div className="card-body p-0">
                            {fetchedDocumentosAdicionais && (
                                <Table
                                    wrapperClasses="mw-100"
                                    columns={
                                        tableviewDocumentosAdicionaisColumns
                                    }
                                    data={fetchedDocumentosAdicionais}
                                    keyField="ID_DOCUMENTO_PRODUTO"
                                    noDataIndication={() => (
                                        <div className="text-black-50 text-center p-3">
                                            Nenhum Documento Adicional
                                            Encontrado
                                        </div>
                                    )}
                                    noHover
                                    noSearch
                                    loading={configEnvelopesLstLoading ?? []}
                                    rowStyle={{ height: 50 }}
                                    bordered={false}
                                    defaultStyle={{ align: "center" }}
                                    striped={true}
                                    rowClasses={"rowClasses"}
                                    center={true}
                                    noPagination={true}
                                    sizePerPage={100}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="d-flex w-100 justify-content-end mt-3">
                <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={
                        !lstEnvelopesLst ||
                        inserirEnvelopeLoading ||
                        informacoesEnvelopeLoading
                    }
                    onClick={() => {
                        if (lstEnvelopesLst) {
                            executeInserirEnvelope({
                                ID_CASO,
                                ID_ENVELOPE_DOCUSIGN:
                                    informacoesEnvelope?.ID_ENVELOPE ?? 0,
                                // DS_GUID_ENVELOPE:
                                //     informacoesEnvelope?.GUID ?? "",
                                DS_LOG:
                                    informacoesEnvelope?.DS_MENSSAGEM_LOG ?? "",
                                DS_STATUS: informacoesEnvelope?.DS_STATUS ?? "",
                                DT_CRIACAO:
                                    informacoesEnvelope?.DT_CADASTRO ?? "",
                                LST_DOCUMENTOS_EXCLUIDOS: documentoExcluidos,
                                LST_DOCUMENTOS_ADICIONAIS:
                                    fetchedDocumentosAdicionais,
                                ID_ENVELOPE_DOCUSIGN_CONFIG:
                                    props.idEnvelopeDocusignConfig,
                                LST_DOCUMENTO_CASO: lstDocsCaso,
                            });
                        }
                    }}
                >
                    {inserirEnvelopeLoading ? (
                        <Spinner size="sm" />
                    ) : (
                        <FontAwesomeIcon icon={faPaperPlane} />
                    )}{" "}
                    Gerar Envelope
                </button>
            </div>
        </>
    );
}
